import { render, staticRenderFns } from "./tonglian.vue?vue&type=template&id=0d4ce9a2&scoped=true"
import script from "./tonglian.vue?vue&type=script&lang=js"
export * from "./tonglian.vue?vue&type=script&lang=js"
import style0 from "./tonglian.vue?vue&type=style&index=0&id=0d4ce9a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4ce9a2",
  null
  
)

export default component.exports